import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { QNameFieldComponent } from './q-name-field.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@xref/ngx';

@NgModule({
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatInputModule,
    FontAwesomeModule,
    ReactiveFormsModule,
    TranslateModule
  ],
  exports: [QNameFieldComponent],
  declarations: [QNameFieldComponent]
})
export class QNameFieldModule {}
